import './main.css';

import {BrowserRouter, Route, Routes} from "react-router-dom";
import { Page } from "../../pages/page";
import { Error404 } from "../../pages/error404";

function Main() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Page />} />
                <Route path="/*" element={<Error404 />} />
            </Routes>
         </BrowserRouter>
        )
    }

export default Main